var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center container-geral-lancar-pagamento"},[_c('div',{staticClass:"container-components-lancar-pagamento",attrs:{"role":"tablist"}},[_c('BillDetails')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }